export const isQuizQuestionComplete = (question = {}) => {
  const questionText = (question.questionText || "").trim();
  const options = question.options || [];
  const correctOptions = options.filter(
    (option) => option.isCorrect && (option.text || "").trim() !== ""
  );
  return (
    questionText !== "" &&
    Number(question.marks) > 0 &&
    options.length >= 2 &&
    options.every((option) => (option.text || "").trim() !== "") &&
    (question.questionType === "multiple_choice"
      ? correctOptions.length >= 1
      : correctOptions.length === 1) &&
    (question.questionType !== "true_false" || options.length === 2)
  );
};

export const isQuizQuestionStarted = (question = {}) =>
  (question.questionText || "").trim() !== "" ||
  (question.options || []).some((option) => (option.text || "").trim() !== "");

export const prepareQuizQuestionsForSave = (questions = []) => {
  const startedQuestions = questions.filter(isQuizQuestionStarted);
  return {
    questions: startedQuestions,
    incompleteIndex: startedQuestions.findIndex((question) => !isQuizQuestionComplete(question)),
  };
};
